export const TestRunStatuses = {
  Passed: 'Passed',
  Failed: 'Failed',
  Skipped: 'Skipped',
} as const

export const TestRunExecutionSources = {
  Workflow: 'Workflow',
  Ci: 'CI',
  Manual: 'Manual',
} as const

export interface TestRun {
  id: string
  testCaseId: string
  automatedTestName: string
  runAt: string
  status: string
  durationMs: number
  errorMessage: string | null
  errorStack: string | null
  failedStepIndex: number | null
  failedStepName: string | null
  executionSource: string
  sourceRef: string
}

export interface TestRunFilters {
  status?: string
  executionSource?: string
  fromDate?: string
  toDate?: string
}

export interface TestCaseAutomationLink {
  id: string
  testCaseId: string
  testName: string
  testPath: string
  linkedOn: string
  linkedByWorkflowRunId: string
}
